import ENVIRONMENT from '@/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const appInsights: ApplicationInsights = new ApplicationInsights({
  config: {
    connectionString: ENVIRONMENT.CONEXION_STRING,
    loggingLevelTelemetry: 2,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    disableFetchTracking: false,
  },
});
appInsights.loadAppInsights();

export abstract class Dictionary {
  public static generate(inputObjects: any[]) {
    const dictionary: any = {};
    inputObjects?.forEach((object: any) => {
      const key = Object.getOwnPropertyNames(object)[0];
      dictionary[key] = object[key];
    });

    return dictionary;
  }
}

const InsightService = {
  logPageView(name?: string, url?: string) {
    appInsights.trackPageView({
      name,
      uri: url,
    });
  },

  logEvent(name: string, properties: any[]) {
    if (properties) {
      const dictionary = Dictionary.generate(properties);
      appInsights.trackEvent({ name }, dictionary);
    } else appInsights.trackEvent({ name });
  },

  logException(error: Error, severityLevel?: number) {
    appInsights.trackException({
      exception: error,
      severityLevel,
    });
  },

  logTrace(message: string, properties?: any[]) {
    if (properties) {
      const dictionary = Dictionary.generate(properties);
      appInsights.trackTrace({ message }, dictionary);
    } else appInsights.trackTrace({ message });
  },

  startTelemetry(message: string, properties?: { [key: string]: any }) {
    const telemetryInitializer = (envelope: any) => {
      const additionalData: { [key: string]: any } = {};
      Object.entries(properties ?? {}).forEach(([values]) => {
        Object.entries(values).forEach(([key, value]) => {
          additionalData[key] = value;
        });
      });
      additionalData.message = message;
      Object.assign(envelope.data, additionalData);
    };
    appInsights.addTelemetryInitializer(telemetryInitializer);
  },
};

export default InsightService;
